import applyMiddleware from './apply-middleware'
import logAPIThrowsMiddleware from './log-api-throws'
import throwAPIErrorsMiddleware from './throw-api-errors'
import { DataMiddlewareType } from './types'

// No authRedirectMiddleware: a public app must not bounce 401/403 to Sheriff.
export const PUBLIC_MIDDLEWARE = [
  throwAPIErrorsMiddleware(/[4-5]\d\d/),
  logAPIThrowsMiddleware()
] as DataMiddlewareType[]

export const applyPublicMiddleware = applyMiddleware(PUBLIC_MIDDLEWARE)

export default applyPublicMiddleware
